/** Tipos Fiscais dos clientes */
export interface ClienteTipoFiscal {
    id: number;
    nome: string;
    descricao?: string;
}

export const clienteTipoFiscalConsumidorFinal: ClienteTipoFiscal = {
    id: 1,
    nome: 'Consumidor Final',
    descricao: 'Clientes que adquirem produtos ou serviços para uso e consumo próprio, sem a intenção de revender'
};

export const clienteTipoFiscalExportador: ClienteTipoFiscal = {
    id: 2,
    nome: 'Exportador',
    descricao: 'Clientes que compram produtos para exportação'
};

export const clienteTipoFiscalIndustria: ClienteTipoFiscal = {
    id: 3,
    nome: 'Indústria',
    descricao: 'Clientes que compram insumos para a produção de outros bens'
};

export const clienteTipoFiscalOrgaoPublico: ClienteTipoFiscal = {
    id: 4,
    nome: 'Orgão Público',
    descricao: 'Clientes que são entidades governamentais'
};

export const clienteTipoFiscalProdutorRural: ClienteTipoFiscal = {
    id: 5,
    nome: 'Produtor Rural',
    descricao: 'Clientes que são produtores rurais'
};

export const clienteTipoFiscalRevendedor: ClienteTipoFiscal = {
    id: 6,
    nome: 'Revendedor',
    descricao: 'Clientes que compram produtos com a intenção de revendê-los, por exemplo, atacadistas e distribuidores'
};

export const clienteTipoFiscalSemFinsLucrativos: ClienteTipoFiscal = {
    id: 7,
    nome: 'Sem Fins Lucrativos',
    descricao: 'Organizações que não possuem fins lucrativos, por exemplo, ONGs'
};

export const clienteTipoFiscalSolidarioICMS: ClienteTipoFiscal = {
    id: 8,
    nome: 'Solidário de ICMS',
    descricao: 'Clientes que são solidário de ICMS'
};

export const clienteTiposFiscais: ClienteTipoFiscal[] = [
    clienteTipoFiscalConsumidorFinal,
    clienteTipoFiscalExportador,
    clienteTipoFiscalIndustria,
    clienteTipoFiscalOrgaoPublico,
    clienteTipoFiscalProdutorRural,
    clienteTipoFiscalRevendedor,
    clienteTipoFiscalSemFinsLucrativos,
    clienteTipoFiscalSolidarioICMS
];

/** Verifica se o tipo fiscal do cliente é igual a Consumidor Final */
export function isClienteTipoFiscalConsumidorFinal(tipoFiscal: number): boolean {
    return tipoFiscal === clienteTipoFiscalConsumidorFinal.id;
}

/** Verifica se o tipo fiscal do cliente é igual a Exportador */
export function isClienteTipoFiscalExportador(tipoFiscal: number): boolean {
    return tipoFiscal === clienteTipoFiscalExportador.id;
}


/** Verifica se o tipo fiscal do cliente é igual a Indústria */
export function isClienteTipoFiscalIndustria(tipoFiscal: number): boolean {
    return tipoFiscal === clienteTipoFiscalIndustria.id;
}


/** Verifica se o tipo fiscal do cliente é igual a Orgão Público */
export function isClienteTipoFiscalOrgaoPublico(tipoFiscal: number): boolean {
    return tipoFiscal === clienteTipoFiscalOrgaoPublico.id;
}


/** Verifica se o tipo fiscal do cliente é igual a Produtor Rural */
export function isClienteTipoFiscalProdutorRural(tipoFiscal: number): boolean {
    return tipoFiscal === clienteTipoFiscalProdutorRural.id;
}


/** Verifica se o tipo fiscal do cliente é igual a Revendedor */
export function isClienteTipoFiscalRevendedor(tipoFiscal: number): boolean {
    return tipoFiscal === clienteTipoFiscalRevendedor.id;
}


/** Verifica se o tipo fiscal do cliente é igual a Sem Fins Lucrativos */
export function isClienteTipoFiscalSemFinsLucrativos(tipoFiscal: number): boolean {
    return tipoFiscal === clienteTipoFiscalSemFinsLucrativos.id;
}


/** Verifica se o tipo fiscal do cliente é igual a Solidário de ICMS */
export function isClienteTipoFiscalSolidarioICMS(tipoFiscal: number): boolean {
    return tipoFiscal === clienteTipoFiscalSolidarioICMS.id;
}
